<template>
  <!--<div>-->
  <div class="partnersMain">
    <!--banner+导航-->
    <div class="bannerBox">
      <img ref="homeBanner" src="../../../assets/img/aboutBanner.jpg" />
      <div class="topTextBox">
        <!--导航-->
        <top-nav></top-nav>
        <!--<top-nav :nav-index1="6"></top-nav>-->

        <div
          class="aboutBannerText animated"
          :class="mm4 ? 'fadeInUp' : 'hideBox'"
        >
          <div class="title">OUR COMPANY</div>
          <div class="contentText">
            <p>
              Supay Technology Pty Ltd started its payment services in 2015 in
              Sydney, Australia. Now we have branch office in Melbourne, and
              have expanded our business in Brisbane QLD, Adelaide SA, Hobart
              TAS and London.
            </p>
            <p>
              We are committed to providing the world-leading aggregated payment
              service, so that customers can enjoy convenient and efficient
              mobile payment anywhere anytime
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="aboutContent">
      <div class="about01" id="m1" :style="contentH">
        <div class="leftBox">
          <img src="../../../assets/icon/aboutImg1.png" ref="imgH" />
        </div>
        <div class="rightBox animated" :class="mm1 ? 'fadeInRight' : 'hideBox'">
          <div class="textBox">
            <div class="titleText">OUR COMPANY</div>
            <div class="contentText">
              <p class="texts">
                To satisfy the increasing payment demands of enterprises and
                businesses engaged in the cross- border trading, SuperiorPay
                developes the "global payment solution" with "cross-border
                payment, mobile payment, O2O payment, multi-channel auditing,
                big-data-based risk control, and online marketing" as the
                business cores.
              </p>
              <p class="texts">
                It solves the problems of Internet transaction, such as"low
                payment conversion, unsystematic service fee, and high trading
                risks”, greatly promotes the efficiency of payment processing
                and boosts the improvement of the online trading industry.
              </p>
            </div>
          </div>
        </div>
        <div style="clear: both;"></div>
      </div>

      <div class="about02" id="m2" :style="contentH">
        <div class="rightBox">
          <div class="textBox animated" :class="mm2 ? 'fadeInLeft' : 'hideBox'">
            <div class="titleText">OUR PAYMENT PRODUCT</div>
            <div class="contentText">
              <p class="texts">
                SuperiorPay has covered the most mainstream mobile payment
                methods including Alipay and WeChat Pay. It is equipped with
                automatic service fee calculation and one-stop financial data
                management and supports multi-channel account checking, easy
                backstage operation and strong statistical functions. We are
                able to create group accounts for businesses, which can keep you
                abreast of the business status of your branches.
              </p>
            </div>
          </div>
        </div>
        <div class="leftBox">
          <img src="../../../assets/icon/aboutImg2.png" />
        </div>
        <div style="clear: both;"></div>
      </div>

      <div class="about01" id="m3" :style="contentH">
        <div class="leftBox">
          <img src="../../../assets/icon/aboutImg3.png" />
        </div>
        <div class="rightBox animated" :class="mm3 ? 'fadeInRight' : 'hideBox'">
          <div class="textBox">
            <div class="titleText">SECURITY</div>
            <div class="contentText">
              <p class="texts">
                In terms of security, our company is authorised with the
                Australian financial license, with the funds managed by
                Australian bank. The company is in official cooperation with
                WeChat and Alipay and employs AML（Anti Money Laundering）and AF
                (Anti-Fraud) regulations for risk control. Our infrastructure is
                with bank-grade security. Data transmission and storage adopts
                encryption algorithm, which allows the funds credited into the
                account safely and in time.
              </p>
            </div>
          </div>
        </div>
        <div style="clear: both;"></div>
      </div>
    </div>

    <!--底部-->
    <Footer></Footer>
  </div>
  <!--</div>-->
</template>

<script>
import topNav from "./nav";
import Footer from "@/components/Footer"
let timer = null; //定义初始值
export default {
  name: "aboutUs",
  components: { topNav,Footer },
  props: {
    step: {
      //此数据是控制动画快慢的
      type: Number,
      default: 50,
    },
  },
  data() {
    return {
      mm1: false,
      mm2: false,
      mm3: false,
      mm4: false,
      contentH: {
        height: "",
      },
    };
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll); //监听页面滚动事件
  },
  mounted() {
    document.documentElement.scrollTop = 0;

    // console.log("aa",this.$refs.imgH.offsetHeight);
    if (this.$refs.imgH.offsetHeight === 0) {
      if (window.innerWidth > 1600) {
        this.contentH.height = "880px";
      } else {
        this.contentH.height = "630px";
      }
    } else {
      this.contentH.height = this.$refs.imgH.offsetHeight - 10 + "px";
    }

    this.mm4 = true;
    // console.log(window.innerWidth)
    if (window.innerWidth > 1366) {
      window.addEventListener("scroll", this.handleScroll);
    } else {
      this.mm1 = true;
      this.mm2 = true;
      this.mm3 = true;
    }
  },
  methods: {
    toTop() {
      // 动画

      timer = setInterval(function () {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        // this.isTop = true
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    },

    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      var offsetTop1 = document.querySelector("#m1").offsetTop;
      var offsetTop2 = document.querySelector("#m2").offsetTop;
      var offsetTop3 = document.querySelector("#m3").offsetTop;

      if (scrollTop > offsetTop1 - 600) {
        this.mm1 = true;
      } else {
        this.mm1 = false;
      }
      if (scrollTop > offsetTop2 - 600) {
        this.mm2 = true;
      } else {
        this.mm2 = false;
      }
      if (scrollTop > offsetTop3 - 600) {
        this.mm3 = true;
      } else {
        this.mm3 = false;
      }
    },
    navClick2(url) {
      this.$router.push(url);
    }
  },
};
</script>

<style scoped>
body {
  min-width: 1345px;
}

.aboutBannerText {
  width: 25%;
  float: right;
  padding-right: 25%;
  min-width: 460px;
  margin-top: 15%;
}
.aboutBannerText .title {
  font-size: 1.5rem;
  font-family: OpenSans600;
  color: #fff;
  width: 100%;
  line-height: 6rem;
}
.aboutBannerText .contentText {
  width: 100%;
  height: auto;
}
.aboutBannerText .contentText > p {
  width: 100%;
  height: calc(100% - 10rem);
  font-family: Montserrat300;
  font-size: 0.875rem;
  color: #fff;
  line-height: 1.8rem;
}

.partnersMain {
  width: 100%;
  height: auto;
}
.partnersMain .bannerBox {
  width: 100%;
  height: auto;
  position: relative;
}
.partnersMain .bannerBox > img {
  width: 100%;
}
.partnersMain .bannerBox .topTextBox {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

/*内容部分*/
.aboutContent {
  width: 100%;
  height: auto;
  padding: 0rem;
  background-color: #fff;
  margin-top: -3px;
  overflow: hidden;
}

/*模块1*/
/*height: 56.25rem;*/
.about01 {
  width: 100%;
  height: auto;
  background-color: #fff;
  margin-top: -3px;
  position: relative;
}
.about01 .leftBox {
  width: 50%;
  height: 100%;
  float: left;
}
.about01 .leftBox > img {
  width: 100%;
  height: 100%;
}
.about01 .rightBox {
  width: 50%;
  height: 100%;
  float: right;
  position: relative;
}
.about01 .rightBox .textBox {
  width: 48%;
  height: 23.6rem;
  padding: 3rem 4rem;
  overflow: hidden;
  position: absolute;
  left: -10%;
  top: 22%;
  background-color: #fff;
  box-shadow: 0 0 30px 0px rgba(0, 0, 0, 0.2);
}
.about01 .rightBox .textBox .titleText {
  font-size: 1.5rem;
  font-family: OpenSans600;
  color: #4a4a4a;
  width: 100%;
  line-height: 4rem;
  text-align: center;
}
.about01 .rightBox .textBox .contentText {
  width: 100%;
  height: calc(100% - 10rem);
  font-family: Montserrat300;
  font-size: 0.875rem;
  color: #4a4a4a;
  line-height: 1.6rem;
  text-align: center;
}
.about01 .rightBox .textBox .contentText .texts {
  margin-top: 2rem;
}

/*模块2*/
.about02 {
  width: 100%;
  height: auto;
  background-color: #fff;
  margin-top: 0px;
  position: relative;
}
.about02 .rightBox {
  width: 50%;
  height: 100%;
  position: absolute;
  left: 0;
}
.about02 .rightBox .textBox {
  width: 48%;
  height: 23.6rem;
  padding: 3rem 4rem;
  overflow: hidden;
  position: absolute;
  right: -10%;
  top: 22%;
  background-color: #fff;
  box-shadow: 0 0 30px 0px rgba(0, 0, 0, 0.2);
}
.about02 .rightBox .textBox .titleText {
  font-size: 1.5rem;
  font-family: OpenSans600;
  color: #4a4a4a;
  width: 100%;
  line-height: 4rem;
  text-align: center;
}
.about02 .rightBox .textBox .contentText {
  width: 100%;
  height: calc(100% - 10rem);
  font-family: Montserrat300;
  font-size: 0.875rem;
  color: #4a4a4a;
  line-height: 1.6rem;
  text-align: center;
}
.about02 .rightBox .textBox .contentText .texts {
  margin-top: 2rem;
}
.about02 .leftBox {
  width: 50%;
  height: 100%;
  float: right;
}
.about02 .leftBox > img {
  width: 100%;
  height: 100%;
}

.hideBox {
  display: none;
}

@media screen and (max-width: 1600px) {
  .about01 .rightBox .textBox {
    width: 70%;
    padding: 1.5rem 2rem;
    top: 17%;
  }
  .about02 .rightBox .textBox {
    width: 70%;
    padding: 1.5rem 2rem;
    top: 17%;
  }
}
.uline{
  /* height:1px; */
  margin-top: 10px;
  border-bottom: #4a4a4a 1px solid;
}
.privacy {
  /* border-top: #4a4a4a 1px solid; */
  margin-top: 10px;
}
</style>
